var kind    = require("enyo/kind"),
    svgLogo = require("app/theme/assets/logo-large.svg").default;

module.exports = kind(/** @lends  app.ui.logo.SvgLogo.prototype */ {

    /**
     * @private
     */
    name: "app.ui.logo.SvgLogo",

    /**
     * @private
     */
    classes: "app-ui-logo-svg-logo",

    /**
     * @private
     */
    tag: "svg",

    /**
     * @private
     */
    attributes: {
        viewbox: svgLogo.viewBox
    },

    /**
     * @private
     */
    components: [{
        tag:        "use",
        attributes: {
            "xlink:href": "#" + svgLogo.url.split("#").pop()
        }
    }]
});
